import { Button, CircularProgress, Container, FormControl, InputLabel, MenuItem, Select, Typography } from "@material-ui/core";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import allActions from "../../../redux/actions";
import translate from "../../../i18n/translate";
import "./CultureCentreLocation.scss";
import ErrorPage from "../../shared/ErrorPage/ErrorPage";
import { useNavigate, useLocation } from "react-router-dom";
import ReactGA from "react-ga";
import { languageDropdown } from "../../../globalConstants";
import { LOCALES } from "../../../i18n/locales";
import { getRandomNumber } from "../../shared/utils/sharedUtils";

const CultureCentreLocation: React.FC = () => {
    const GALocation = useLocation();
    const history = useNavigate();
    const dispatch = useDispatch();
    const allInfo = useSelector((state: any) => state);  
    const [isCultureCentreLocationFeatureEnabled, setIsCultureCentreLocationFeatureEnabled] = useState(false);
    const [isLocation, setIsLocation] = useState<any>();
    const [isSelectLocationDisabled, setIsSelectLocationDisabled] = useState(true);
    const [isSelectTopicDisabled, setIsSelectTopicDisabled] = useState(false);
    const [isBody, setIsBody] = useState<any>();
    const [currentPage, setCurrentPage] = useState(0);
    const [selectedCountryCode, setSelectedCountryCode] = useState<string>('');
    const [topic, setTopic] = useState("");
    const [language, setLanguage] = useState("");
    const [loaderFlag, setLoaderFlag] = useState(true);


    /** useEFFECTS **/

    useEffect(() => {
        if (!allInfo.peopleInformation.isLoading && !allInfo.peopleInformation.isFailed && allInfo.peopleInformation.data) {
            if ((allInfo.peopleInformation.data.getpeopleInformation.serviceConfiguration.features.substring(27, 28)) === "1") {
                setIsCultureCentreLocationFeatureEnabled(true);
            } else {
                setIsCultureCentreLocationFeatureEnabled(false);
                setLoaderFlag(false);
            }
            initGoogleAnalytics();
        }
    }, [allInfo.peopleInformation, GALocation]);

    useEffect(() => {
        if(!allInfo.peopleInformation.isLoading && !allInfo.peopleInformation.isFailed && allInfo.peopleInformation.data){
            initGoogleAnalytics();
        }
    }, [isBody]);

    useEffect(() => {
        if(!allInfo.cultureCentreCountries.data) {
            dispatch(allActions.cultureCentreAction.getCountriesList());
        }
    }, []);

    useEffect(() => {
        if(!allInfo.cultureCentreCountries.isLoading && !allInfo.cultureCentreCountries.isFailed && !selectedCountryCode && allInfo.cultureCentreCountries.data) {
            setLoaderFlag(true);
            const cultureCenterUrl = window.location.pathname.split("/");
            const codeFromUrl = cultureCenterUrl[cultureCenterUrl.length - 1];
            setSelectedCountryCode(codeFromUrl);
            setIsSelectLocationDisabled(false);
        }
    }, [allInfo.peopleInformation, allInfo.cultureCentreCountries]);

    useEffect(() => {
        const licenses: any = allInfo?.peopleInformation?.data?.getpeopleInformation?.license;
        if (licenses?.length) {
          const productLanguage = licenses[0].productName?.split(" ")[2]?.toUpperCase() || "ENGLISH";
          const allLanguagesCodes: any = {...LOCALES};
          let languageCode: any = allLanguagesCodes[productLanguage] || "EN";
          languageCode = languageCode === "ES-ES" ? "ES-MX" : languageCode;
          setLanguage(languageCode);
          const cultureCenterUrl = window.location.pathname.split("/");
          const codeFromUrl = cultureCenterUrl[cultureCenterUrl.length - 1];          
          updateCultureNotesData(codeFromUrl.toUpperCase(), languageCode)
        }
    },[allInfo.peopleInformation])

    /**
     * Make api to get culture center data
     * @param url 
     * @returns 
     */
    async function cultureCenterJson(url: string) {
        setLoaderFlag(true);
        let cultureCenterData: any = await fetch(url)
                                            .then((res: any) => res.json())
                                            .then((data: any) => {
                                                setLoaderFlag(false);
                                                return data;
                                            })
                                            .catch((err: any) => {
                                                console.log(err, "cultureCenterJson")
                                                setLoaderFlag(false);
                                            });
        return cultureCenterData;
    }

    /**
     * On change event for select dropdown
     * @param event 
     * @param eventType
     * @param selectionValue
     * @param localeData 
     * @param isEvent 
     */
    const handleCountryChange = async(event: any, eventType: boolean) => {
        const country = eventType ? event.target.value : event;   
        const lang: string = language || languageDropdown[0].code;
        updateCultureNotesData(country, lang)
    };

    const handleLanguageChange = async(event: any, isEvent: boolean) => {
        const country = isEvent ? event.target.value : event;
        let language: string = country.split("-")[0];
        updateCultureNotesData(selectedCountryCode, language);
        setLanguage(country);
    }

    const handleTopicChange = (event: any, isEvent: boolean, selectionValue: string, localeData: any) => {
        const inputValue = isEvent ? event.target.value : selectionValue;
        const filterData: any = isEvent ? isLocation : localeData;
        let article = filterData.content.filter((data: any) => data.title === inputValue);
        if(isEvent) {
            let getIndex = filterData.content.findIndex((x: any) => x.title === event.target.value);
            setCurrentPage(getIndex);
        }
        setTopic(inputValue);
        setIsBody(article[0]);
    }

    /**
     * paginationClick next previous topic
     * @param isPrevBtn 
     */
    const paginationClick = (isPrevBtn: boolean = false) => {  
        const nextPrev = isPrevBtn ? currentPage - 1 : currentPage + 1;
        if ((currentPage >= 0) && (nextPrev >= 0) && (currentPage < isLocation.content.length)) {
            let nextarticlesList = isLocation.content.filter((data: any) => data.title === isLocation.content[nextPrev].title);
            setIsBody(isLocation.content[nextPrev]);
            setTopic(nextarticlesList[0].title);
            setCurrentPage(nextPrev);
        }
    }

    /**
     * Custom functions to form data 
     * @param country
     * @param lang
     * @param countrySelected
     * @param language
     */

    async function fetchCultureNotesData(countrySelected: string, language: string) {
        let environment = (process.env.REACT_APP_ENV === "dynamic") ? "test" : process.env.REACT_APP_ENV;
        if(language){
            let langForURL = language.includes("-") || language === "EN" ? language : `${language}-${language}`;
            langForURL = langForURL === "ES-ES" ? "ES-MX" : langForURL;
            let langUrl = language === "EN" ? `${countrySelected.toUpperCase()}` : `${countrySelected.toUpperCase()}/${langForURL}`; 
            let url = `${process.env.REACT_APP_BLOB_STORAGE}/content/${environment}/culture_centre/${langUrl}/default.json`;  
            let data = await cultureCenterJson(url);
            return data;
        }              
    }

    const updateCultureNotesData = async (country: string, lang: string) => {
        const localeData: any = await fetchCultureNotesData(country, lang);
        if (!localeData) return false;
        let updatedDescription = localeData.content[0].description.replace(/h6/g, "div")
        localeData.content[0].description=updatedDescription;
        setIsLocation(localeData);
        setSelectedCountryCode(localeData.country.code);
        history(`/culturecenter/${country.toLowerCase()}`);
        setCurrentPage(0);
        setIsSelectTopicDisabled(false);
        handleTopicChange("", false, localeData.content[0].title, localeData);
    }

    const redirecttocultureNotes = () => history("/culturecenter");

    const initGoogleAnalytics = () => {
        if ((allInfo.peopleInformation.data.getpeopleInformation.serviceConfiguration.features.substring(84, 85)) === "1") {
            const trackingId: string = process.env.REACT_APP_GA_TRACKING_ID || "";
            ReactGA.initialize(trackingId);
            const culturepath  = `${selectedCountryCode +'/'+ isBody?.title}`;
            const url = window.location.pathname + '/' + culturepath;
            ReactGA.set({ page: url });
            ReactGA.pageview(url);
        }
    };
   
    return (
        <div className="culturenotes">
            <Container>
                { allInfo.cultureCentreCountries.data && allInfo.peopleInformation.data ?
                    <React.Fragment>
                    { isCultureCentreLocationFeatureEnabled ?
                        <React.Fragment>
                            <div data-testid="culturenotesID" className="culturenotes-heading">
                               <button className="remove-button-default-style" onClick={redirecttocultureNotes}> <h3>{translate("feature_culture_centre_title")}</h3></button>
                            </div>
                            <div className="culturenotes-location">
                                <div className="culturenotes-location-selectbox">
                                    <FormControl variant="outlined" disabled={isSelectLocationDisabled}>
                                        <InputLabel id="SAR">{translate("SAR")}</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-outlined-label-location"
                                            id="Countries"
                                            value={selectedCountryCode}
                                            onChange={(event) => handleCountryChange(event, true)}
                                            label={translate("SAR")}
                                        >
                                            {allInfo.cultureCentreCountries.data.map((option: any, index: number) => {
                                                return (
                                                    <MenuItem value={option.code} key={getRandomNumber(index)}>
                                                        {option.name}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="culturenotes-location-selectbox">
                                    <FormControl variant="outlined" disabled={isSelectTopicDisabled}>
                                        <InputLabel id="SAT">{translate("SAT")}</InputLabel>
                                        {isLocation && 
                                            <Select
                                                labelId="demo-simple-select-outlined-label-country-location"
                                                id="Topics"
                                                value={topic || isLocation?.content[0].title}
                                                onChange={(event) => handleTopicChange(event, true, "", "")}
                                                label={translate("SAT")}
                                            >
                                                {isLocation ? isLocation.content.map((option: any, index: number) => {
                                                        return (
                                                            <MenuItem value={option.title} key={getRandomNumber(index)}>
                                                                {option.title}
                                                            </MenuItem>
                                                        );
                                                    })
                                                    : ""
                                                }
                                            </Select>
                                        }
                                    </FormControl>
                                </div>
                                <div className="culturenotes-location-selectbox">
                                    <FormControl variant="outlined" disabled={isSelectTopicDisabled}>
                                        <InputLabel id="SAA">{translate("SAA")}</InputLabel>
                                        { 
                                            <Select
                                                labelId="demo-simple-select-outlined-label-country-location"
                                                id="Languages"
                                                value={language}
                                                onChange={(event) => handleLanguageChange(event, true)}
                                                label={translate("SAA")}
                                            >
                                                {languageDropdown.map((option: any, index: number) => {
                                                        return (
                                                            <MenuItem value={option.code}    key={getRandomNumber(index)}>
                                                                {option.language}
                                                            </MenuItem>
                                                        );
                                                    })                                        
                                                }                                    
                                            </Select>
                                        }
                                    </FormControl>
                                </div>
                            </div>
                            {   isLocation && !loaderFlag ? (
                                <React.Fragment>
                                    <div className="culturenotes-content">
                                        <div className="culturenotes-content-image" >
                                            <img src={isLocation.meta.image} alt="culture_notes" className="culturenotes-content-image-main" />
                                            <div className="culturenotes-content-image-sub"><img src={isLocation.meta.flag} alt="culture_notes" /></div>
                                        </div>
                                        <h2 className="culturenotes-content-heading">{isLocation.title}</h2>
                                        { isBody &&                                          
                                                <div className="culturenotes-content-section">
                                                    <h2 className="culturenotes-content-section-title">{isBody.title}</h2>
                                                    <div className="culturenotes-content-section-image">
                                                        <img src={isBody ? isBody.image : ""} alt="flag" className="CN-image" />
                                                    </div>
                                                    <div className="culturenotes-content-section-text" dangerouslySetInnerHTML={{ __html: (isBody.description) }} />                         
                                                </div>

                                        }         
                                    </div>
                                    {isBody &&
                                        
                                            <div className="culturenotes-pagination">
                                                <div>
                                                    {currentPage + 1}/{isLocation.content.length}
                                                </div>
                                                <button  className="culturenotes-pagination-arrowbtn" onClick={() => paginationClick(true)}>
                                                    <ArrowBackIosIcon></ArrowBackIosIcon>
                                                </button>
                                                <Button type="button" variant="contained" color="primary" onClick={() => paginationClick()} 
                                                    disabled={currentPage === (isLocation.content.length - 1)} 
                                                >
                                                    <Typography>{translate("button_next")}</Typography>
                                                </Button>
                                            </div>
                                       
                                    }
                                </React.Fragment>
                                ) 
                                : 
                                <div className="culturenotes-loader-container">
                                    <CircularProgress size={50} color="primary" />
                                </div>
                            }
                        </React.Fragment>
                        :
                        <div className="culture-Notes-Location-Errorpage">
                            <ErrorPage status={401} />
                        </div>
                    }
                    </React.Fragment>
                :
                <div data-testid="culturecenter-loader-containerId" className="culturenotes-loader-container-main culturecenter-loader-container">
                    <CircularProgress size={50} color="primary" />
                </div>
            }
            </Container>
        </div>
    );
}

export default CultureCentreLocation;